/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  CreateAffiliateProgramOptions,
  CreateAffiliateProgramResponses,
} from '../types/CreateAffiliateProgram'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description ADMIN or INTEGRATOR required. Integrators are restricted to their own tenant; ADMIN overrides other roles. tenant_id is required. Set is_active to true to create an active program.
 * @summary Create an affiliate program
 * {@link /v1/affiliate_programs}
 */
export function createAffiliateProgram<ThrowOnError extends boolean = true>(
  options: Options<CreateAffiliateProgramOptions, ThrowOnError>,
): Unwrappable<RequestResult<CreateAffiliateProgramResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/affiliate_programs',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CreateAffiliateProgramResponses, ThrowOnError>>,
  )
}
